const baseOptions = {
  timeout: 2500,
  horizontalAlign: "center",
  verticalAlign: "top"
};

export const notifySuccess = (vm, message, options = {}) => {
  vm.$notify({
    ...baseOptions,
    message,
    icon: "thumb_up",
    type: "success",
    ...options
  });
};

export const notifyError = (vm, message, options = {}) => {
  vm.$notify({
    ...baseOptions,
    message,
    icon: "cancel",
    type: "danger",
    ...options
  });
};
